export const handleImageLink = image => {
	if (image?.includes("http")) {
		return image;
	} else {
		// eslint-disable-next-line no-undef
		return `${process.env.REACT_APP_MAIN_URL}/${image}`;
	}
};

export const getId = obj => obj?._id || obj?.id;

export const getFullDate = (date, locale) => {
	if (!date) return;
	return new Date(date).toLocaleDateString(
		locale === "ar" ? "ar-EG" : "en-US",
		{
			month: "long",
			day: "numeric",
			year: "numeric",
			hour: "numeric",
			minute: "numeric",
		}
	);
};

// حول أي مسار نسبي لمسار مطلق (حسب الـ API عندك)
const toAbsolute = (p = "") =>
	!p
		? ""
		: /^https?:\/\//i.test(p)
		? p
		: `${process.env.REACT_APP_API_URL}/${String(p).replace(/^\/+/, "")}`;

export const getIconSrc = icon => {
	if (!icon) return "";
	return icon instanceof File ? URL.createObjectURL(icon) : toAbsolute(icon);
};
